import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ActivityEntry, ActivityEntryText } from 'app/domains/common-ui/ActivityLog';
import { getIcon } from './utils';
export function SignRequestCancelled(props) {
    const { actor, timestamp } = props;
    const fallbackName = t({
        message: 'Unknown',
        comment: 'Fallback name when user does not exist',
    });
    const userName = (actor === null || actor === void 0 ? void 0 : actor.name) || fallbackName;
    return (<ActivityEntry appearance="danger" icon={getIcon('danger')} timestamp={timestamp} text={<ActivityEntryText>
          <Trans comment="Esigning activity - User cancelled the eSigning request">
            <b>{userName}</b> cancelled the eSigning request
          </Trans>
        </ActivityEntryText>}/>);
}
